import styled from 'styled-components';
import glass from '../../../../assets/images/glass.png';

export const Container = styled.section`
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-direction: column;
  gap: 40px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    b {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.primary.main};
    }
  }

  div {
    display: flex;
    align-items: center;
    gap: 8px;

    p {
      margin-bottom: -4px;

      span {
        margin-right: 4px;
        font-size: 20px;
      }
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    display: flex;
    flex-direction: column;
  }
`;

export const Rows = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 28px;
  gap: 48px;

  @media ${({ theme }) => theme.devices.tablet} {
    display: flex;
    flex-direction: column;
  }
`;

export const Collumn = styled.div`
  width: 100%;
  /* max-width: 350px; */
  margin-top: ${({ $top }) => ($top ? `${$top}px` : '0px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: ${({ $top }) => ($top ? `20px` : '0px')};
  }

  button {
    width: 80%;
    color: ${({ theme }) => theme.colors.grey.white};
  }

  a {
    color: ${({ theme }) => theme.colors.primary.main};

    span {
      font-size: 14px;
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;

export const Group = styled.div`
  width: 100%;
  position: relative;
  border-radius: 32px;
  z-index: 0;

  .fire {
    padding: 32px 52px;

    @media ${({ theme }) => theme.devices.mobile} {
      h1 {
        margin: 20px 0;
      }
    }
  }

  &::before {
    width: 120px;
    height: 160px;
    position: absolute;
    content: '';
    right: -20px;
    top: -30px;
    z-index: -20;

    background-image: url(${({ $before }) => $before});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 32px;
    padding: 2px;
    background: linear-gradient(
      225deg,
      rgba(255, 255, 255, 0) 3.51%,
      rgba(255, 255, 255, 0.2) 96.49%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
  }
`;

export const Background = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-radius: 32px;
  padding: 32px 40px;
  overflow: hidden;

  background-image: url(${glass});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 20px;
  }

  > div {
    width: fit-content;
    max-width: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media ${({ theme }) => theme.devices.mobile} {
      width: 100%;
    }

    p {
      text-align: center;
      text-transform: uppercase;
    }

    h1 {
      text-align: center;
      font-family: 'Anton', sans-serif;
      font-size: 68px;
      margin: -8px 0;

      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 48px;
        margin: 0;
      }
    }
  }

  .bottom {
    padding-bottom: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};
  }

  .medium {
    width: 100%;
  }
`;

export const Name = styled.section`
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;

  h3 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 300;
    font-size: 20px;
  }

  h2 {
    font-size: 36px;
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    margin-bottom: -8px;
  }
`;

export const Body = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 28px;

  small {
    font-size: 12px;
    font-weight: 400;
  }

  button {
    width: 100%;
  }

  .cancel {
    background-color: transparent;
    border: 0;

    span {
      font-size: 14px;
      color: ${({ theme }) => theme.colors.primary.main};
    }
  }
`;

export const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  & + & {
    padding-top: 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.grey.white};
  }

  > div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10%;

    div {
      width: 50%;

      h4 {
        font-size: 16px;
        text-transform: uppercase;
        margin-bottom: 2px;
      }

      span {
        font-size: 12px;
      }
    }
  }

  button {
    margin: 4px 0px;
  }
`;
